/* eslint-disable linebreak-style */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { LockOpenOutlined } from '@material-ui/icons';
import { withStyles, CircularProgress } from '@material-ui/core';
import { EHRresetpassword } from 'services/user/action';
import styles from '../../../SignIn/style';

const Passwordreset = props => {
  const { classes } = props;

  useEffect(() => {
    fetchUser();
  }, []);

  const parseQueryString = url => {
    var objURL = {};
    url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function (
      _$0,
      $1,
      _$2,
      $3
    ) {
      objURL[$1] = $3;
    });
    return objURL;
  };

  const fetchUser = async () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    let url = window.location.href;
    var params = parseQueryString(url);
    const res = await props.EHRresetpassword(params['token']);
    if (res.status === 200) {
      let newurl = res.data;
      var loginparams = parseQueryString(newurl);

      const queryParams = new URLSearchParams({
        username: loginparams['username'],
        ehrid: loginparams['ehrid'],
        token: params['token']
      }).toString();

      if (isAndroid) {
        // Redirect to Android app
        window.location.href = `com.ehrzip://ActivateAccountForm?${queryParams}`;
      } else if (isIOS) {
        // Redirect to iOS app
        window.location.href = `com.ehrzip.app://ActivateAccountForm?${queryParams}`;
      }
    }
  };

  return (
    <span>
      <div
        className={classes.contentBodyMsg}
        style={{ position: 'relative' }}
      >
        <div className={classes.contentHeader}>
          <LockOpenOutlined />
        </div>
        <div className={classes.contentInner}>
          <CircularProgress size={50} className={classes.progress} />
        </div>
      </div>
    </span>
  );
};

Passwordreset.propTypes = {
  history: PropTypes.object
};

const mapDispatchToProps = { EHRresetpassword };

const mapStateToProps = _state => ({});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(Passwordreset))
);
